import { getReportingLinks } from "../links";
import { sendCallToAPI } from "../../../common/generic_functions";

//Function for fethcing all workspace tags
export const getWorkSpaceTags = async (setOptionsWorkstag, workspaceId, store, enableAlert) => {
  const linksWorksTag = `${getReportingLinks("workSapceTagApi")}${workspaceId}/`;
  let res_worksTag = await sendCallToAPI(linksWorksTag, store.accessToken);
  if (res_worksTag?.length >= 0) {
    setOptionsWorkstag(res_worksTag);
  } else {
    enableAlert({ type: "danger", text: "No workspace tags available!" });
  }
  return res_worksTag;
};

//Function for adding new workspace tags
export const addWorkSpaceTag = async (setLoading, dataObject, setOptionsWorkstag, workspaceId, store, enableAlert) => {
  setLoading(true);
  const link = `${getReportingLinks("workSapceTagApi")}${workspaceId}/`;
  let res = await sendCallToAPI(link, store.accessToken, dataObject, "POST");
  if (res.id) {
    await getWorkSpaceTags(setOptionsWorkstag, workspaceId, store);
    enableAlert({ type: "success", text: "Applied successfully!", time: 1200 });
  } else {
    enableAlert({ type: "danger", text: "Something went wrong. Try again later" });
  }
  setLoading(false);
  return res;
};

//Function for update name of workspace tags
export const renameWorkSpaceTag = async (setLoading, dataObject, setOptionsWorkstag, workspaceId, store, enableAlert) => {
  setLoading(true);
  const link = `${getReportingLinks("workSapceTagApi")}${dataObject["deleteWorkTag"]["value"]}/`;
  let data = { name: dataObject["newName"], color: dataObject["tagColor"] };
  let res = await sendCallToAPI(link, store.accessToken, data, "PUT");
  if (res.id) {
    await getWorkSpaceTags(setOptionsWorkstag, workspaceId, store);
    enableAlert({ type: "success", text: "Applied successfully!",  time: 1200 });
  } else {
    enableAlert({ type: "danger", text: "Something went wrong. Try again later" });
  }
  setLoading(false);
  return res;
};

//Function for deleting workspace tags
export const deleteWorkSpaceTag = async (setLoading, dataObject, setTagChanges, setOptionsWorkstag, workspaceId, store, enableAlert) => {
  setLoading(true);
  const link = `${getReportingLinks("workSapceTagApi")}${dataObject["deleteWorkTag"]["value"]}/`;
  let res = await sendCallToAPI(link, store.accessToken, dataObject, "DELETE");
  if (res.name) {
    let newtags = await getWorkSpaceTags(setOptionsWorkstag, workspaceId, store);
    setTagChanges(newtags);
    enableAlert({ type: "success", text: "Applied successfully3!",  time: 1200 });
  } else {
    enableAlert({ type: "danger", text: "Something went wrong. Try again later" });
  }

  setLoading(false);
  return res;
};
